<ng-container *appIfIsMobile>
  <div *ngIf="isProgressBarStarted" class="backdrop"></div>

  <ng-container *ngIf="isLoggedIn && post">
    <app-navbar-top-post-new
      *ngIf="!isProgressBarStarted"
      [title]="currentRestaurant? currentRestaurant?.nameView : (currentUser.username)"
      [postPageType]="postPageType"
      [post]="post"
      [postRestaurantFormGroup]="postFoodFormGroup"
      (shareClick)="onShareClick()"
      (backClick)="goBack()"
    ></app-navbar-top-post-new>

    <div class="container container-post-new has-navbar-both max-width px-0 min-h-100vh overflow-scroll">
      <div class="post-new overflow-scroll">
        <div class="post-new-body d-flex flex-column overflow-scroll">
          <div class="position-relative">
            <div *ngIf="!isCropperMode" class="img-preview" (click)="focusEditor()">
              <img
                [src]="imageData"
                class="w-100"
                style="max-height: 600px; overflow: scroll;"
                alt=""/>
            </div>

            <div
              *ngIf="isCropperMode && post.images.length > 0"
              class="position-relative overflow-scroll"
            >
              <app-image-cropper
                [image]="post.images[0]"
                [imageData]="imageData"
                [rotation]="rotation"
                [showGrid]="showGrid"
                (imageCropped)="setCroppedImage($event)"
              ></app-image-cropper>
            </div>

            <div
              [ngClass]="{'active': needToShowKeyboard, 'post-new-caption-touch': !needToShowKeyboard}"
              class="post-new-caption p-4 text-white"
            >
              <p *ngIf="postPageType.isUser && food" class="font-weight-500 mb-2">
                {{ food.title }}
              </p>

              <form
                *ngIf="!postPageType.isUser && needToShowKeyboard"
                [formGroup]="postFoodFormGroup.form"
                class="form-food-new"
                (ngSubmit)="onSubmit()"
              >
                <div
                  *ngIf="post.type.isPlate"
                  class="post-new-food-input-group input-group mb-2 text-white"
                >
                  <input
                    #foodTitle
                    [placeholder]="
                      food ? food.title :
                      ('Item name' +
                        (isFormSubmitted && !postFoodFormGroup.form.valid ? ' required' : '')
                      )"
                    [ngbTypeahead]="search"
                    [inputFormatter]="formatter"
                    [resultFormatter]="formatter"
                    type="text"
                    required
                    class="post-new-food-title form-control invalid-placeholder test-food-name"
                    formControlName="title"
                    (selectItem)="selectItem($event)"
                    (input)="onInput($event)"
                  >

                  <span class="input-group-text px-0">$</span>

                  <input
                    [min]="0"
                    type="number"
                    required
                    class="post-new-food-price form-control pl-0"
                    inputmode="decimal"
                    pattern="[0-9]*"
                    formControlName="price"
                  >
                </div>
              </form>

              <quill-editor
                #quill
                [(ngModel)]="post.caption"
                [placeholder]="needToShowKeyboard ? 'Caption...' : ''"
                tabindex="0"
                theme="bubble"
              >
                <div quill-editor-toolbar>
                  <span class="ql-formats">
                    <button class="ql-bold"></button>
                    <button class="ql-italic"></button>
                    <button class="ql-underline"></button>
                  </span>
                </div>
              </quill-editor>
            </div>
          </div>

          <div class="position-relative">
            <div class="post-new-image-actions d-flex justify-content-between">
              <button
                appHrefNone
                [ngClass]="{'visibility-hidden': isInstagram}"
                class="btn btn-default btn-circle flex-content-vc-hc"
                (click)="toggleCropperMode()"
              >
                <i class="icon-v2 scale"></i>
              </button>

              <div *ngIf="postPageType.isUser" class="flex-content-vc-hc">
                <a appHrefNone class="text-dark cursor-pointer" (click)="focusEditor()">Caption</a>
              </div>

              <div *ngIf="!postPageType.isUser" class="flex-content-vc-hc flex-column w-75 px-10px">
                <app-segmented-button
                  [buttons]="segments"
                  [activeIndex]="1"
                  (change)="onPostRestaurantTypeChange($event)"
                  class="w-100"
                ></app-segmented-button>
              </div>

              <button
                appHrefNone
                [ngClass]="{'visibility-hidden': isInstagram}"
                class="btn btn-default btn-circle flex-content-vc-hc"
                (click)="rotateImage()"
              >
                <i class="icon-v2 rotate"></i>
              </button>
            </div>

            <div class="post-new-image-actions d-flex justify-content-between">
              <div class="empty-div"></div>

              <div class="flex-content-vc-hc flex-column w-75 px-10px">
                <div *ngIf="post.type.isPlace">
                  <div class="btn-group btn-group-toggle" data-toggle="buttons">
                    <label
                      *ngIf="!postPageType.isUser && post.type.isPlace"
                      class="custom-control custom-radio custom-radio-secondary"
                    >
                      <input
                        [id]="post.type.list.PLACE_OUTSIDE"
                        [value]="post.type.list.PLACE_OUTSIDE"
                        [checked]="post.type.isPlaceOutside"
                        type="radio"
                        class="custom-control-input"
                        name="options"
                      >
                      <span class="custom-control-label cursor-pointer"> Outside </span>
                    </label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                    <label
                      *ngIf="!postPageType.isUser && post.type.isPlace"
                      class="custom-control custom-radio custom-radio-secondary"
                    >
                      <input
                        [id]="post.type.list.PLACE_INSIDE"
                        [value]="post.type.list.PLACE_INSIDE"
                        [checked]="post.type.isPlaceInside"
                        type="radio"
                        class="custom-control-input"
                        name="options"
                      >
                      <span class="custom-control-label cursor-pointer"> Inside </span>
                    </label>&nbsp;&nbsp;
                  </div>
                </div>

                <div *ngIf="post.type.isPlate">
                  <app-picker
                    [picker]="favoritePicker"
                    [value]="post.type.value"
                    [classes]="'icon-v2 ' + (post.type.isPlateEaten ? 'goal-black' : 'heart-red')"
                    (selectedValue)=plateTypeChange($event)
                  ></app-picker>
                </div>
              </div>

              <div class="empty-div"></div>
            </div>

            <div class="d-flex justify-content-center align-items-center">
              <div
                *ngIf="!postPageType.isUser"
                class="d-flex justify-content-center align-items-center w-255px"
              >
                <a
                  appHrefNone
                  class="cursor-pointer w-61-5px text-dark position-absolute top-13rem"
                  (click)="focusEditor()"
                >
                  {{ needToShowKeyboard ? 'Position' : 'Caption' }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-container *appIfIsDesktop>
  <div class="modal-body p-0 flex-content-vc-hc flex-column">
    <div class="min-h-100vh flex-content-vc-hc flex-column">
      <div class="modal-box bg-white">
        <div class="user-authentication text-center p-3">
          <div *ngIf="isLoggedIn && post" class="d-flex flex-column">

            <div class="w-100 h-44px d-flex">
              <div class="flex-content-hc w-100 font-weight-500 font-size-1rem text-black">
                {{ currentRestaurant?.nameView }}
              </div>
            </div>

            <div class="position-relative">
              <div class="img-preview mx-3">
                <img [src]="imageData" class="w-100 h-100" alt="Post Image" />
              </div>
            </div>

            <div class="d-flex justify-content-center w-100 mt-3">
              <div *ngIf="post.type.isPlate" class="h-55px w-100 mx-3 d-flex justify-content-between">
                <form
                  [formGroup]="postFoodFormGroup.form"
                  class="form-food-new"
                  (ngSubmit)="onSubmit()"
                >
                  <div
                    *ngIf="post.type.isPlate"
                    class="post-new-food-input-group input-group mb-2 h-55px w-100 text-white"
                  >
                    <input
                      #foodTitle
                      [placeholder]="
                      food ? food.title :
                      ('Item name' +
                        (isFormSubmitted && !postFoodFormGroup.form.valid ? ' required' : '')
                      )"
                      [ngbTypeahead]="search"
                      [inputFormatter]="formatter"
                      [resultFormatter]="formatter"
                      type="text"
                      required
                      class="post-new-food-title form-control invalid-placeholder test-food-name w-50-p"
                      formControlName="title"
                      (selectItem)="selectItem($event)"
                      (input)="onInput($event)"
                    >

                    <span class="input-group-text px-0">$</span>

                    <input
                      [min]="0"
                      type="number"
                      required
                      class="post-new-food-price form-control pl-0"
                      inputmode="decimal"
                      pattern="[0-9]*"
                      formControlName="price"
                    >
                  </div>
                </form>

                <div *ngIf="post.type.isPlate" class="ml-3 h-32px w-32px">
                  <div
                    appNgbDropdownOnHover
                    ngbDropdown
                    [placement]="'bottom'"
                    class="d-flex w-100 justify-content-center"
                  >
                    <a
                      appHrefNone
                      ngbDropdownToggle
                      class="cursor-pointer hide-arrow outline-none d-flex"
                    >
                      <span
                        [ngClass]="{
                          'heart-red h-32px': post.type.isPlateFavorite,
                          'goal-black': post.type.isPlateEaten,
                        }"
                        class="icon-v2"
                      ></span>
                    </a>

                    <div ngbDropdownMenu class="bg-dark backdrop-filter-blur-5">
                      <a
                        appHrefNone
                        class="dropdown-item flex-content-vc"
                        (click)="plateTypeChange(PostType.PLATE_FAVORITE)"
                      >
                        <span class="ml-3 flex-fill text-white" value="post.type.isPlateFavorite"> Favorite </span>
                      </a>

                      <a
                        appHrefNone
                        class="dropdown-item flex-content-vc"
                        (click)="plateTypeChange(PostType.PLATE_EATEN)"
                      >
                        <span class="ml-3 flex-fill text-white" value="post.type.isPlateEaten"> Eaten </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="post.type.isPlace">
                <div class="post-new-image-actions d-flex justify-content-between h-55px">
                  <div class="empty-div"></div>

                  <div class="flex-content-vc-hc flex-column w-75 px-10px">
                    <div *ngIf="post.type.isPlace">
                      <div class="btn-group btn-group-toggle" data-toggle="buttons">
                        <label
                          *ngIf="!postPageType.isUser && post.type.isPlace"
                          class="custom-control custom-radio custom-radio-secondary"
                        >
                          <input
                            [id]="post.type.list.PLACE_OUTSIDE"
                            [value]="post.type.list.PLACE_OUTSIDE"
                            [checked]="post.type.isPlaceOutside"
                            type="radio"
                            class="custom-control-input"
                            name="options"
                          >
                          <span class="custom-control-label cursor-pointer text-black"> Outside </span>
                        </label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                        <label
                          *ngIf="!postPageType.isUser && post.type.isPlace"
                          class="custom-control custom-radio custom-radio-secondary"
                        >
                          <input
                            [id]="post.type.list.PLACE_INSIDE"
                            [value]="post.type.list.PLACE_INSIDE"
                            [checked]="post.type.isPlaceInside"
                            type="radio"
                            class="custom-control-input"
                            name="options"
                          >
                          <span class="custom-control-label cursor-pointer text-black"> Inside </span>
                        </label>&nbsp;&nbsp;
                      </div>
                    </div>

                    <div *ngIf="post.type.isPlate">
                      <app-picker
                        [picker]="favoritePicker"
                        [value]="PostType.PLATE_EATEN"
                        [classes]="'icon-v2 ' + (post.type.isPlateEaten ? 'goal-black' : 'heart-red')"
                        (selectedValue)=plateTypeChange($event)
                      ></app-picker>
                    </div>
                  </div>

                  <div class="empty-div"></div>
                </div>
              </ng-container>
            </div>

            <div class="btn-group btn-group-toggle d-flex justify-content-center w-100 mt-3">
              <div class="post-new-image-actions d-flex justify-content-between mx-3 w-100">
                <div *ngIf="!postPageType.isUser" class="flex-content-vc-hc flex-column w-100 px-10px">
                  <app-segmented-button
                    [buttons]="segments"
                    [activeIndex]="1"
                    (change)="onPostRestaurantTypeChange($event)"
                    class="w-100"
                  ></app-segmented-button>
                </div>
              </div>
            </div>

            <div class="mt-3 mb-3-5rem px-3 mx-3">
              <input
                type="text"
                class="form-control"
                placeholder="Caption..."
                [(ngModel)]="post.caption"
              />
            </div>

            <div class="d-flex justify-content-center mt-4">
              <button class="btn btn-primary mx-4 w-100" (click)="onShareClick()">Post</button>
            </div>
            <div class="d-flex justify-content-center mt-2">
              <button class="btn btn-light mx-4 w-100" (click)="closeModal()">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
